import script from "./access.manager.tab.vue?vue&type=script&lang=ts&setup=true"
export * from "./access.manager.tab.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__